import { format } from 'date-fns';
import FormTableCalculateDisplay from '../../../components/form-table-calculate/form-table-calculate.component';
import FormTableDatePicker from '../../../components/form-table-date-picker/form-table-date-picker.component';
import FormTableHeaderCell from '../../../components/form-table-header-cell/form-table-header-cell.component';
import FormTableInlineDelete from '../../../components/form-table-inline-delete/form-table-inline-delete.component';
import FormTableSelect from '../../../components/form-table-select/form-table-select.component';
import FormTableTextField from '../../../components/form-table-text-field/form-table-text-field.component';

export const WORK_ORDER_PICKING_INFO = {
  formTitle: "Work Order",
  path: "/workorders",
  subPath: "/picks",
  listPage: "/work-orders",
  
}

export const WORK_ORDER_PICKING_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "workOrder",
      fieldItems: [
        {
          label: "WO Number",
          type: "text",
          name: "workOrderNumber",
          initialFocus: false,
          disabled: true,
          defaultValue: `WO-`
        },
        {
          label: "Location",
          type: "select",
          name: "Location",
          initialFocus: false,
          muliselect: false,
          url: "/locations",
          disabled: true,
          validationProps: {
            required: "Location is required"
          }
        },
        // {
        //   label: "Assign To",
        //   type: "select",
        //   name: "User",
        //   required: false,
        //   initialFocus: false,
        //   muliselect: false,
        //   url: "/users"
        // },
        {
          label: "WO Date",
          type: "date",
          name: "workOrderDate",
          initialFocus: false,
          disabled: true,
          validationProps: {
            required: "WO date is required"
          }
        },
        {
          label: "Finish Date",
          type: "date",
          name: "finishDate",
          disabled: true,
          initialFocus: false,
        }
      ]
    },
    finishedProductDetails: {
      sectionType: "Finished Product details",
      sectionTypeId: "finishedProductDetails",
      multiForm: false,
      expandable: true,
      isExpand: true,
      addButton: true,
      breakPoint: 1,
      fieldName: "finishedProduct",
      fieldItems: [
        {
          label: "Product",
          type: "select",
          name: "Item",
          initialFocus: false,
          muliselect: false,
          autofiller: true,
          url: "/items",
          disabled: true,
          validationProps: {
            required: "Item is required"
          }
        },
        {
          label: "Quantity",
          type: "text",
          name: "qty",
          initialFocus: false,
          disabled: true,
          defaultValue: 1
        },
      ]
    },
    tableForm: {
      sectionType: "Component Items",
      sectionTypeId: "tableForm",
      fieldName: "items",
      expandable: true,
      isExpand: true,
      hasNoAction: false,
      hasProgress: false,
      hasAutoFillButton: true,
      isDisable: false,
      tableColumns: [
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Component Product Code/Name"}
                required={true}
              />
            )
          },
          accessor: "item",
          width: 200,
          Cell: ({ row }) => {
            const endpointUrl = "/items";
            const validationProps = {
              required: "Item Code is required"
            }

            return (<FormTableSelect
              fieldName={"items"}
              fieldItemName={"Item"}
              rowNumber={row.id}
              endpointUrl={endpointUrl}
              validationProps={validationProps}
              disabled={row.isDisable}
              shouldTriggerSelectedField={true}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"UoM"}
                required={true}
              />
            )
          },
          accessor: "unitOfMeasure",
          width: 80,
          Cell: ({ row }) => {
            const endpointUrl = "/unitofmeasures";
            const validationProps = {
              required: "UoM is required"
            }

            return (<FormTableSelect
              fieldName={"items"}
              fieldItemName={"UnitOfMeasure"}
              rowNumber={row.id}
              value={row.value}
              endpointUrl={endpointUrl}
              validationProps={validationProps}
              disabled={true}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Qty"}
                required={true}
              />
            )
          },
          accessor: "qtyPicked",
          width: 80,
          Cell: ({ row }) => {
            const validationProps = {
              required: "Qty is required"
            }

            return (<FormTableTextField
              fieldName={"items"}
              fieldItemName={"qtyPicked"}
              rowNumber={row.id}
              valueType={"number"}
              validationProps={validationProps}
              align="right"
              disabled={row.isDisable}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Branch"}
                required={true}
              />
            )
          },
          accessor: "location",
          width: 160,
          Cell: ({ row }) => {
            const endpointUrl = "/locations";
            const validationProps = {
              required: "Location is required"
            }

            return (<FormTableSelect
              fieldName={"items"}
              fieldItemName={"Location"}
              rowNumber={row.id}
              value={row.value}
              endpointUrl={endpointUrl}
              validationProps={validationProps}
              disabled={row.isDisable}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Picked Date"}
                required={true}
              />
            )
          },
          accessor: "pickedDate",
          width: 80,
          Cell: ({ row }) => {
            const validationProps = {
              required: "Picked date is required"
            }

            return (<FormTableDatePicker
              fieldName={"items"}
              fieldItemName={"pickedDate"}
              rowNumber={row.id}
              value={row.value}
              validationProps={validationProps}
              disabled={row.isDisable}
            />)
          }
        },
        {
          id: "action",
          width: 70,
          Cell: ({ row, toggleRowSelected }) => {
            const uuid = row.original.uuid;
            return (<FormTableInlineDelete
              rowNumber={row.id}
              toggleRowSelected={toggleRowSelected}
            />)
          }
        }
      ]
    },
  },
  watchFields: []
}
